/* =========================================================
   1️⃣ POPUP FUNCTIONALITY
========================================================= */

document.addEventListener("DOMContentLoaded", function () {

  const openBtn = document.getElementById("openTentPopup");
  const closeBtn = document.getElementById("closeTentPopup");
  const overlay = document.getElementById("tentPopupOverlay");

  if (!openBtn || !closeBtn || !overlay) return;

  function openPopup() {
    overlay.style.display = "flex";

    setTimeout(() => {
      overlay.classList.add("active");
    }, 10);
  }

  function closePopup() {
    overlay.classList.remove("active");

    setTimeout(() => {
      overlay.style.display = "none";
    }, 400);
  }

  openBtn.addEventListener("click", openPopup);
  closeBtn.addEventListener("click", closePopup);

  overlay.addEventListener("click", function (e) {
    if (e.target === overlay) {
      closePopup();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closePopup();
    }
  });

});


/* =========================================================
   2️⃣ COLOR SWATCHES FUNCTIONALITY (Filter Images by Color)
========================================================= */

document.addEventListener("DOMContentLoaded", function () {

  function normalize(text) {
    return (text || "").toLowerCase().trim();
  }

  function filterMediaByColor(colorName) {
    if (!colorName) return;

    colorName = normalize(colorName);

    /* ---------- 1. Filter Main Media Grid ---------- */

    const mediaItems = document.querySelectorAll(
      ".product-media-grid .product-media-item"
    );

      mediaItems.forEach(function (item) {
        const mediaColor = normalize(item.getAttribute("data-media-img"));
        const img = item.querySelector("img");
        const altText = img ? normalize(img.getAttribute("alt")) : "";

        if (mediaColor.includes(colorName) || altText.includes(colorName)) {
          item.classList.add("show");    // Add class instead of display:block
          item.classList.remove("hide"); // Optional: remove a 'hide' class if you have one
        } else {
          item.classList.remove("show"); // Remove the show class
          item.classList.add("hide");    // Optional: add a 'hide' class
        }
      });

    /* ---------- 2. Filter Product Thumbnails ---------- */

    const thumbnails = document.querySelectorAll(".product-thumbnail");
    let firstVisibleThumbnail = null;

    thumbnails.forEach(function (thumb) {

      const thumbColor = normalize(thumb.getAttribute("data-media-alt"));

      if (thumbColor.includes(colorName)) {

        thumb.style.display = "inline-block";

        if (!firstVisibleThumbnail) {
          firstVisibleThumbnail = thumb;
        }

      } else {

        thumb.style.display = "none";
        thumb.classList.remove("active");

      }

    });

    /* ---------- 3. Auto Activate First Thumbnail ---------- */

    if (firstVisibleThumbnail) {
      firstVisibleThumbnail.classList.add("active");
      firstVisibleThumbnail.click();
    }
  }

  /* ---------- Get Selected Color ---------- */

  function getSelectedColor() {

    const selectedRadio = document.querySelector(
      '.color-swatch-selector input[type="radio"]:checked'
    );

    if (!selectedRadio) return null;

    const label = selectedRadio.nextElementSibling;

    return label ? label.getAttribute("title") : null;
  }

  /* ---------- On Page Load ---------- */

  const initialColor = getSelectedColor();
  if (initialColor) {
    filterMediaByColor(initialColor);
  }

  /* ---------- On Color Change ---------- */

  document.addEventListener("change", function (e) {

    if (e.target.matches('.color-swatch-selector input[type="radio"]')) {

      const selectedColor = getSelectedColor();

      if (selectedColor) {
        filterMediaByColor(selectedColor);
      }

    }

  });

});


/* =========================================================
   3️⃣ ADDITIONAL PRODUCT AUTO ADD TO CART
========================================================= */

// document.addEventListener("DOMContentLoaded", function () {

//   const form = document.querySelector(".product-form");
//   if (!form) return;

//   form.addEventListener("submit", function () {

//     const additionalInput = document.querySelector(".ctm_additional_prd");
//     if (!additionalInput) return;

//     const additionalVariantId = additionalInput.value;

//     setTimeout(function () {

//       fetch("/cart/add.js", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({
//           id: additionalVariantId,
//           quantity: 1
//         })
//       })
//         .then(res => res.json())
//         .then(() => {
//           updateCartBubble();
//           document.dispatchEvent(new Event("cart:refresh"));
//         })
//         .catch(error => {
//           console.error("Error adding additional product:", error);
//         });

//     }, 800);

//   });

// });


// /* =========================================================
//    4️⃣ INSTANT CART BUBBLE UPDATE
// ========================================================= */

// function updateCartBubble() {

//   fetch("/cart.js")
//     .then(res => res.json())
//     .then(cart => {

//       const bubble = document.querySelector("#CartBubble");
//       if (!bubble) return;

//       bubble.textContent = cart.item_count;

//     })
//     .catch(error => {
//       console.error("Cart update error:", error);
//     });

// }


// document.addEventListener("product:added-to-cart", function () {
//   const additionalInput = document.querySelector(".ctm_additional_prd");
//   if (!additionalInput) return;

//   // Wait 500ms before adding additional product
//   setTimeout(() => {
//     fetch("/cart/add.js", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ id: additionalInput.value, quantity: 1 })
//     })
//     .then(res => res.json())
//     .then(() => {
//       // After additional product added, fetch updated cart once
//       return fetch("/cart.js");
//     })
//     .then(res => res.json())
//     .then(cart => {
//       // Update bubble count
//       const bubble = document.querySelector("#CartBubble");
//       if (bubble) bubble.textContent = cart.item_count;

//       // Dispatch event for other UI updates if needed
//       document.dispatchEvent(new Event("cart:refresh"));
//     })
//     .catch(console.error);
//   }, 50);  // 500 milliseconds delay
// });






/* =========================================================
   5️⃣ VARIANT SIZE CLICK IMAGE SYNC
========================================================= */

const productContainer = document.querySelector("body");

productContainer.addEventListener("click", function (event) {

  const label = event.target.closest(".ctm_size");
  if (!label) return;

  const picker = label.closest(".product-variant-picker");
  if (!picker) return;

  const checkedColorInput = picker.querySelector(
    '.color-swatch-selector input[type="radio"]:checked'
  );
  if (!checkedColorInput) return;

  const colorValue = checkedColorInput.value.trim().toLowerCase();
  const activeThumbnail = document.querySelector(".product-thumbnail.active");

  if (!activeThumbnail) return;

  const mediaAlt = activeThumbnail.getAttribute("data-media-alt");

  if (mediaAlt && mediaAlt.trim().toLowerCase() === colorValue) {
    activeThumbnail.click();
  }

});


/* =========================================================
   6️⃣ CART DRAWER - REMOVE ALL ITEMS
========================================================= */

// $(document).ready(function() {
//   $(document).on('click', '#remove-all-items', function(e) {
//     e.preventDefault();

//     // Clear the cart
//     $.ajax({
//       type: 'POST',
//       url: '/cart/clear.js',
//       dataType: 'json',
//       cache: false, // ensure no cache
//       success: function() {

//         // Reload cart modal from server (fresh)
//         $.get('/?section_id=cart-modal', { _: new Date().getTime() }, function(html) {
//           var $newModalContent = $(html).find('#cart-modal').html();

//           if ($newModalContent) {
//             $('#cart-modal').html($newModalContent);
//           }

//           // Reload CartBubble fresh
//           $.get('/?section_id=cart-bubble', { _: new Date().getTime() }, function(bubbleHtml) {
//             var $newBubble = $(bubbleHtml).find('#CartBubble');
//             if ($newBubble.length) {
//               $('#CartBubble').replaceWith($newBubble);

//               // Hide if empty
//               var itemCount = parseInt($newBubble.text()) || 0;
//               if (itemCount === 0) {
//                 $('#CartBubble').hide();
//               } else {
//                 $('#CartBubble').show();
//               }
//             }
//           });

//         });

//       },
//       error: function() {
//         alert('Cart clear karne me kuch problem hui. Please try again.');
//       }
//     });
//   });
// });




document.addEventListener("DOMContentLoaded", function() {

    const mediaQuery = window.matchMedia("(min-width: 1024px)");

    function initSticky() {

        if (!mediaQuery.matches) return; // screen choti hai, exit

        // ===== Script 1: Custom Featured Products =====
        const stickyElements = document.querySelectorAll(".Custom_featured_Products .product-media");
        const header = document.querySelector("sticky-header"); // Update selector if needed
        let lastScroll = window.scrollY;

        function updateStickyTop(scrollY) {
            const headerHeight = header ? header.offsetHeight : 0;
            stickyElements.forEach(el => {
                if (scrollY > lastScroll) {
                    // Scrolling down
                    el.style.top = `20px`;
                } else {
                    // Scrolling up
                    el.style.top = `${headerHeight}px`;
                }
            });
            lastScroll = scrollY;
        }

        // Initial top set
        updateStickyTop(window.scrollY);

        window.addEventListener("scroll", () => {
            updateStickyTop(window.scrollY);
        });

        window.addEventListener("resize", () => {
            updateStickyTop(window.scrollY);
        });

        // ===== Script 2: Product Page Sticky =====
        const sticky = document.querySelector(".product-page .sticky_main_products");
        const container = document.querySelector(".product-info-inner");

        if (!sticky || !container) return;

        const topOffset = 20;

        function handleScroll() {
            const containerRect = container.getBoundingClientRect();
            const stickyHeight = sticky.offsetHeight;

            const diff = containerRect.bottom - stickyHeight - topOffset;

            if (diff < 0) {
                sticky.style.transform = `translateY(${diff}px)`;
            } else {
                sticky.style.transform = "translateY(0px)";
            }
        }

        window.addEventListener("scroll", handleScroll);
    }

    // Initialize on load
    initSticky();

    // Re-run if window resized and media query changes
    mediaQuery.addEventListener("change", () => {
        initSticky();
    });

});





    const productH1 = document.querySelector('.product-name-wrapper h1');

    function updateH1FromChecked() {
        const checkedInput = document.querySelector('.ctm-Style input:checked');
        if (checkedInput) {
            const label = document.querySelector(`label[for="${checkedInput.id}"]`);
            if (label) {
                productH1.textContent = label.textContent;
            }
        }
    }
    updateH1FromChecked();
    document.body.addEventListener('click', function(e) {
        if (e.target.tagName === 'LABEL' && e.target.closest('.ctm-Style')) {
            const labelText = e.target.textContent;
            productH1.textContent = labelText;
        }
    });



// document.addEventListener('DOMContentLoaded', function () {

//     var productSections = document.querySelectorAll('.product-towel, .product-blanket');
//     if (!productSections.length) return;

//     function safeClickRadio(radio) {
//         if (!radio) return;

//         var picker = radio.closest('variant-picker');
//         if (picker && typeof picker.handleChange === 'function') {
//             picker.handleChange({ target: radio });
//         } else {
//             if (radio.offsetParent !== null) {
//                 radio.click();
//             } else {
//                 radio.checked = true;
//                 radio.dispatchEvent(new Event('change', { bubbles: true }));
//             }
//         }
//     }

//     function updateMainImage(radio) {
//         if (!radio) return;

//         var dataVarImg = radio.getAttribute('data-var-img');
//         var ctmMedia = document.querySelector('.ctm-media img');
//         var ctmMediaSlider = document.querySelector('.ctm_media_slider');

//         if (ctmMedia && dataVarImg) {
//             ctmMedia.setAttribute('src', dataVarImg);
//             ctmMedia.setAttribute('srcset', dataVarImg);
//         }

//         if (radio.closest('.ctm-towel-1') || radio.closest('.ctm-blanket-1')) {
//             if (ctmMediaSlider) ctmMediaSlider.classList.add('image-updated');

//             var secondSection = document.querySelector('.ctm-towel-2, .ctm-blanket-2');
//             if (secondSection) {
//                 setTimeout(function tryClick() {
//                     var availableInputs = Array.from(
//                         secondSection.querySelectorAll('input[type="radio"].var_avlaible')
//                     ).filter(input => !input.disabled);

//                     if (availableInputs.length) {
//                         safeClickRadio(availableInputs[0]);
//                     } else {
//                         setTimeout(tryClick, 300);
//                     }
//                 }, 600);
//             }

//         } else if (radio.closest('.ctm-towel-2') || radio.closest('.ctm-blanket-2')) {
//             if (ctmMediaSlider) ctmMediaSlider.classList.remove('image-updated');
//         }

//         if (typeof updatePrice === 'function') updatePrice();
//     }

//     productSections.forEach(function (section) {

//         section.addEventListener('change', function (event) {
//             if (event.target && event.target.type === 'radio') {
//                 updateMainImage(event.target);
//                 safeClickRadio(event.target);
//             }
//         });

//         var checkedRadio = section.querySelector('input[type="radio"]:checked');
//         updateMainImage(checkedRadio);
//     });

// });

document.addEventListener('DOMContentLoaded', function () {

    function normalize(text) {
        return (text || "").toLowerCase().trim();
    }

    function filterMediaByValue(value) {
        if (!value) return;
        value = normalize(value);

        document.querySelectorAll(".product-media-grid .product-media-item").forEach(item => {
            const img = item.querySelector("img");
            const altText = img ? normalize(img.getAttribute("alt")) : "";
            item.style.display = altText.includes(value) ? "block" : "none";
        });
    }

    function updateMainImage(radio) {
        if (!radio) return;

        var dataVarImg = radio.getAttribute('data-var-img');
        var ctmMedia = document.querySelector('.ctm-media img');

        if (ctmMedia && dataVarImg) {
            ctmMedia.src = dataVarImg;
        }

        if (radio.closest('.ctm-towel-1') || radio.closest('.ctm-blanket-1')) {
            setTimeout(() => {
                var secondSection = document.querySelector('.ctm-towel-2, .ctm-blanket-2');
                if (!secondSection) return;

                var secondRadio = secondSection.querySelector('input[type="radio"]:not(:disabled)');
                if (secondRadio) {
                    secondRadio.checked = true;
                    secondRadio.dispatchEvent(new Event('change', { bubbles: true }));
                    filterMediaByValue(secondRadio.value);
                }
            }, 200);
        }

        if (typeof updatePrice === 'function') updatePrice();
    }

    // ✅ CHANGE EVENT (more reliable than click)
    document.addEventListener('change', function (e) {
        const radio = e.target.closest('input[type="radio"]');
        if (!radio) return;

        // Shopify ko pehle kaam karne do
        setTimeout(() => {
            updateMainImage(radio);
            filterMediaByValue(radio.value);
        }, 100);

    });

});

// document.addEventListener('DOMContentLoaded', function () {

//     var productSections = document.querySelectorAll('.product-towel, .product-blanket');
//     if (!productSections.length) return;

//     // Robust function to safely click / select a radio
//     function forceSelectRadio(radio, retries = 10) {
//         if (!radio) return;

//         if (!radio.disabled) {
//             try {
//                 // Check the radio
//                 radio.checked = true;

//                 // Trigger input/change events
//                 radio.dispatchEvent(new Event('input', { bubbles: true }));
//                 radio.dispatchEvent(new Event('change', { bubbles: true }));

//                 // Try label click if radio click fails
//                 var label = radio.closest('label');
//                 if (label) label.click();
//                 else radio.click();

//             } catch (e) {
//                 console.warn('Radio click error:', e);
//             }
//             return;
//         }

//         // Retry after 300ms if still disabled
//         if (retries > 0) {
//             setTimeout(() => forceSelectRadio(radio, retries - 1), 300);
//         }
//     }

//     // Wait for element if dynamically added
//     function waitForElement(parent, selector, callback) {
//         var el = parent.querySelector(selector);
//         if (el) return callback(el);

//         var observer = new MutationObserver(() => {
//             var el = parent.querySelector(selector);
//             if (el) {
//                 observer.disconnect();
//                 callback(el);
//             }
//         });

//         observer.observe(parent, { childList: true, subtree: true });
//     }

//     // Update main image and handle second section
//     function updateMainImage(radio) {
//         if (!radio) return;

//         var dataVarImg = radio.getAttribute('data-var-img');
//         var ctmMedia = document.querySelector('.ctm-media img');
//         var ctmMediaSlider = document.querySelector('.ctm_media_slider');

//         if (ctmMedia && dataVarImg) {
//             ctmMedia.setAttribute('src', dataVarImg);
//             ctmMedia.setAttribute('srcset', dataVarImg);
//         }

//         // Handle first section (auto select second)
//         if (radio.closest('.ctm-towel-1') || radio.closest('.ctm-blanket-1')) {
//             if (ctmMediaSlider) ctmMediaSlider.classList.add('image-updated');

//             var secondSection = document.querySelector('.ctm-towel-2, .ctm-blanket-2');
//             if (secondSection) {
//                 // Wait until radio available in second section
//                 waitForElement(secondSection, 'input[type="radio"].var_avlaible', function () {
//                     var availableInputs = Array.from(
//                         secondSection.querySelectorAll('input[type="radio"].var_avlaible')
//                     ).filter(input => !input.disabled);

//                     if (availableInputs.length) {
//                         forceSelectRadio(availableInputs[0]);
//                     }
//                 });
//             }

//         } else if (radio.closest('.ctm-towel-2') || radio.closest('.ctm-blanket-2')) {
//             if (ctmMediaSlider) ctmMediaSlider.classList.remove('image-updated');
//         }

//         if (typeof updatePrice === 'function') updatePrice();
//     }

//     // Attach event listeners
//     productSections.forEach(function (section) {

//         section.addEventListener('change', function (event) {
//             if (event.target && event.target.type === 'radio') {
//                 updateMainImage(event.target);
//                 forceSelectRadio(event.target);
//             }
//         });

//         // Initialize first checked radio
//         var checkedRadio = section.querySelector('input[type="radio"]:checked');
//         updateMainImage(checkedRadio);
//     });

// });